const LOAN_GROUPS = Object.freeze({
    HOMEEQUITY: 'HOMEEQUITY',
    CREDITCARD: 'CREDITCARD',
    PERSONAL: 'PERSONAL',
    VEHICLE: 'VEHICLE'
})

export default LOAN_GROUPS